import { AacDecoder } from '../aac/aacDecoder';
import type { DecodedPcmFloat32Channels } from '../aac/types';
import type { EncodedData } from './demuxerTypes';
import { samplingFrequencyInHz } from '../aac/data';
import { safeArrayAccess } from '../util/safeArrayAccess';
import { invariant } from '../util/invariant';

export class PcmSampleFetcher {

  private decoders: AacDecoder[] = [];

  getDecodedPcmFloat32Channels(encodedData: EncodedData): DecodedPcmFloat32Channels {
    if (encodedData.encodedAudioData.length === 0) {
      // No audio
      return {
        sampleRateInHz: 0,
        channels: [],
      };
    }
    const results: DecodedPcmFloat32Channels = {
      sampleRateInHz: encodedData.encodedAudioData[0]!.sampleRateInHz,
      channels: [],
    };
    for (let i = 0; i < encodedData.encodedAudioData.length; i++) {
      const audioData = safeArrayAccess(encodedData.encodedAudioData, i);
      if (this.decoders[i] === undefined) {
        const frequencyIndex = samplingFrequencyInHz.indexOf(audioData.sampleRateInHz);
        if (frequencyIndex === -1) {
          throw new Error(`Invalid frequency: ${audioData.sampleRateInHz}`);
        }

        invariant(audioData.codecSpecificData?.type === 'aac', 'Missing AAC codec specific data');

        this.decoders[i] = new AacDecoder(frequencyIndex, audioData.codecSpecificData.channelConfiguration, false);
      }
      const pcmSamples = this.decoders[i]!.decodeAacFrames(audioData);
      for (let n = 0; n < pcmSamples.channels.length; n++) {
        results.channels.push(safeArrayAccess(pcmSamples.channels, n));
      }
    }

    return results;
  }

}
